<ds-modal
  #demoStockReplshModal
  [dimensionsConfig]="{ width: '500px' }"
  [ds-modal-trigger-for]="demoStockReplshModal"
  [(isModalOpen)]="demoStockReplshModalIsOpen"
  (dismiss)="closeRequestQuoteModal()"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Request Demo Vehicle Quote
  </ds-box-header>
  <ds-box-content>
    <div style="display: flex; align-items: center; gap: 8px">
      <span style="width: 150px">User Requesting:</span>
      <span>{{ modalData.requesterName }}</span>
    </div>
    <br />
    <div style="display: flex; align-items: center; gap: 8px">
      <span style="width: 150px">VIN Number:</span>
      <span>{{ modalData.vin }}</span>
    </div>
    <br />
    <span style="display: flex; align-items: center; gap: 8px">
      <label ds-label for="customerNameText" style="width: 225px">
        Customer Name:
      </label>
      <input
        ds-input
        id="customerNameText"
        type="text"
        placeholder="customer name"
        required
        (input)="onTextChange($event)"
        [(ngModel)]="customerNameModel"
      />
    </span>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="requestQuote()"
    >
      Request Quote
    </button>
  </ds-box-footer>
</ds-modal>
<app-show-quote></app-show-quote>
